module.exports = __webpack_public_path__ + "img/biaoqian.2531ae1c.png";